import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Projects from './components/Projects';
import EnergyEfficiency from './components/EnergyEfficiency';
import HeatPumpsDetailed from './components/HeatPumpsDetailed';
import CaseStudies from './components/CaseStudies';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Hero />
      <main className="flex-grow">
        <Services />
        <About />
        <EnergyEfficiency />
        <HeatPumpsDetailed />
        <CaseStudies />
        <Projects />
      </main>
      <Footer />
    </div>
  );
}

